import { escapeHtml, glyph } from "../lib/util.js";
import { state } from "../lib/state.js";
import { addManyToCart } from "../lib/cart.js";
import { navigate } from "../lib/router.js";

export function renderBossList(els) {
  const bosses = [...(state.bosses || [])].sort((a, b) => a.tier - b.tier);
  els.bossesPanel.innerHTML = `
    <header class="view-head">
      <h2 class="view-title">Boss prep</h2>
      <p class="view-lead">Gear, food, and torch checklists — add everything to your craft cart.</p>
    </header>
    <ul class="stack-list">
      ${bosses
        .map(
          (boss) => `
        <li class="stack-card">
          <button type="button" class="boss-row" data-boss="${escapeHtml(boss.slug)}">
            ${glyph(boss.name, boss.colour)}
            <span class="result-text">
              <span class="result-name">${escapeHtml(boss.name)}</span>
              <span class="result-meta">Tier ${escapeHtml(boss.tier)} · ${escapeHtml(boss.biome)}</span>
            </span>
            <span class="chevron" aria-hidden="true">›</span>
          </button>
        </li>`
        )
        .join("")}
    </ul>
  `;
}

export function renderBossDetail(els, slug) {
  const boss = (state.bosses || []).find((b) => b.slug === slug);
  if (!boss) {
    els.bossPanel.innerHTML = `<p class="empty">Boss not found.</p>`;
    return null;
  }

  const groups = { summon: [], gear: [], food: [], torch: [], other: [] };
  for (const row of boss.checklist || []) {
    const key = groups[row.kind] ? row.kind : "other";
    groups[key].push(row);
  }

  function section(title, rows) {
    if (!rows.length) return "";
    return `
      <section class="section">
        <h3 class="section-title">${escapeHtml(title)}</h3>
        <ul class="check-list">
          ${rows
            .map(
              (r) => `
            <li>
              <button type="button" class="check-row" data-slug="${escapeHtml(r.slug)}">
                ${glyph(r.name, state.details?.[r.slug]?.colour)}
                <span>${escapeHtml(r.name)}</span>
                <span class="chip-qty">${escapeHtml(r.qty)}×</span>
              </button>
            </li>`
            )
            .join("")}
        </ul>
      </section>`;
  }

  els.bossPanel.innerHTML = `
    <header class="view-head">
      <div class="item-hero">
        ${glyph(boss.name, boss.colour)}
        <div>
          <h2 class="view-title">${escapeHtml(boss.name)}</h2>
          <p class="item-meta">Tier ${escapeHtml(boss.tier)} · ${escapeHtml(boss.biome)}</p>
        </div>
      </div>
      <p class="view-lead">${escapeHtml(boss.summary || "")}</p>
      <div class="action-row">
        <button type="button" class="btn primary" id="addAllBoss">Add all to cart</button>
        <button type="button" class="btn ghost" data-route-bosses>All bosses</button>
      </div>
    </header>
    ${section("Summon", groups.summon)}
    ${section("Gear", groups.gear)}
    ${section("Food", groups.food)}
    ${section("Torches / light", groups.torch)}
    ${section("Other", groups.other)}
  `;
  return boss;
}

export function bindBosses(els) {
  els.bossesPanel.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-boss]");
    if (btn) navigate("boss", btn.dataset.boss);
  });

  els.bossPanel.addEventListener("click", (e) => {
    if (e.target.closest("[data-route-bosses]")) {
      navigate("bosses");
      return;
    }
    if (e.target.closest("#addAllBoss")) {
      const routeSlug = location.pathname.match(/\/boss\/([^/]+)/)?.[1];
      const slug = routeSlug ? decodeURIComponent(routeSlug) : null;
      const boss = (state.bosses || []).find((b) => b.slug === slug);
      if (!boss) return;
      addManyToCart(boss.checklist || []);
      const btn = e.target.closest("#addAllBoss");
      btn.textContent = "Added to cart ✓";
      setTimeout(() => {
        btn.textContent = "Add all to cart";
      }, 1200);
      return;
    }
    const row = e.target.closest("[data-slug]");
    if (row) navigate("item", row.dataset.slug);
  });
}
